<template>
  <div style=" position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
z-index: 1020">
    <div class="messaging-modal">
  <div style="
  width: 100%;
    box-shadow: #343434;
    padding: 8px;
    transition: box-shadow 0.2s ease-in-out;
    cursor: pointer;
    z-index: 1021;
    height: calc(70vh);
"
  >
    <forward-messaging :room="forwardRoom" v-if="forwardRoom != null" @go-back="forwardRoom = null"  @close-chat="$emit('close-chat')" />
    <div class="forward-container" v-else>
      <div class="forward-inner">
        <div class="forward-header">
        <div class="forward-wrapper">
          <div class="forward-info-wrapper">
            <div class="forward-text-ellipsis">
              <div class="forward-header-name forward-text-ellipsis">
                  Weiterleitungen
              </div>
            </div>
          </div>
          <div style="display: flex">
            <b-button variant="success" class="btn-pill font-md" style="margin-right: 18px" @click="$emit('forward')">
              Weiterleiten
            </b-button>
            <window-minimize class="icon-1_5x vac-svg-button vac-room-options" fillColor="#16aa13" :size="72" style="color: #000000" @click="$emit('close-chat')"></window-minimize>
          </div>
        </div>
      </div>
        <b-table hover responsive  id="my-table"
                 style="height: 100%; width: 100%;
                 background-color: white; padding-top: 64px;
                  margin-bottom: 0px"
                 :items="forwards"
                 :fields="fields"
                 @row-clicked="rowClicked"
        >
        </b-table>
    </div>
    </div>
  </div>
    </div>
    <div class="messaging-backdrop" @click.prevent="$emit('close-chat')"></div>
  </div>
</template>

<script>

import WindowMinimize from 'vue-material-design-icons/Close.vue'
import ForwardMessaging from "@/views/messaging/forward_messaging.vue";
export default {
  name: "task_forward_messaging",
  components: {
    WindowMinimize,
    ForwardMessaging
  },
  props:{
    forwards: {
      type: Array,
      default: () => []
    },
  },
  data: () => {
    return {
      items: [],
      forwardRoom: null,
      show: false,
      fields: [
        {key: 'create_date', label: 'Datum', formatter: (value, key, item) => {
            if (value === null) {
              return ""
            }
            let event = new Date(value.replace('Z',''));
            let options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: "2-digit", minute: "2-digit" };
            return event.toLocaleDateString('de-DE', options);
          }},
        {key: 'users', label: 'Nutzer im Chat', formatter: (value, key, item) => {
            if (value === null) {
              return ""
            }
            let res = "";
            for (let i = 0; i < value.length; i++) {
              let u = JSON.parse(sessionStorage.getItem(value[i]._id));
              if (u !== null) {
                res += u.first_name + " " + u.surname;
                if (i !== value.length - 1) {
                  res += ", "
                }
              }
            }
            return res;
          }},
        //{key: 'count_messages', label: 'Anz. Nachrichten'}
      ]
    }
  },
  methods: {
    rowClicked(item, index, target) {
      this.forwardRoom = item;
    },
  }
}
</script>

<style scoped>
  .forward-container {
    width: 100%;
    display: block;
    height: 100%;
    max-width: 100%;
    background: #f8f9fa;
    color: #0a0a0a;
    overflow-wrap: break-word;
    white-space: normal;
    border: none;
    border-radius: 8px;
    box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);;
    -webkit-tap-highlight-color: transparent;
  }
  .forward-inner {
    position: relative;
    height: 100%;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column;
    border-radius: 8px;
  }
  .forward-header {
    position: absolute;
    display: flex;
    align-items: center;
    height: 64px;
    width: 100%;
    z-index: 10;
    margin-right: 1px;
    background: #ffffff;
    border-top-right-radius: 4px;
    border-bottom: 1px solid #e1e4e8;;
  }
  .forward-wrapper {
    display: flex;
    align-items: center;
    min-width: 0;
    height: 100%;
    width: 100%;
    padding: 0 16px;
  }
  .forward-header .forward-info-wrapper {
    display: flex;
    align-items: center;
    min-width: 0;
    width: 100%;
    height: 100%;
  }
  .forward-text-ellipsis {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .forward-header-name {
    font-size: 17px;
    font-weight: 500;
    line-height: 22px;
    color: #0a0a0a;
  }

  .messaging-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1020;
    width: 100vw;
    height: 100vh;
    background-color: #000;
    opacity: .5;
  }

  .messaging-modal {
    flex-direction: column;
    justify-content: center;
    height: 100%;
    width: 40vw;
    min-width: 350px;
    margin: 1.75rem auto;
    display: flex;
    align-items: center;
  }

</style>
